import { injectEmspBoInvoiceApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/emsp-bo-invoice.service';

import { baseApi } from '@service/base-api.service';

export const emspBoInvoiceApi = injectEmspBoInvoiceApi(baseApi);

export const {
  useEmspBoGetInvoicesQuery,
  useEmspBoGetInvoiceQuery,
  useLazyEmspBoGetInvoicePdfQuery,
} = emspBoInvoiceApi;
